import PortalClienteService from "services/bases/PortalClienteService";
import * as HttpRequest from 'EstruturaAntiga/assets/httpRequest';

class UsuariosService extends PortalClienteService {
    async ListarUsuarios(dataUrlAtributes) {
        const userSignature = HttpRequest.userSignature();

        const defaultUrlAtributes = {
            tenantCode: userSignature.tenantCode,
            codigoCliente: userSignature.accountNumber ? userSignature.accountNumber : '',
            filtro: '',
            tamanhoPagina: 10,
            skipToken: ''
        };

        const urlAtributes = Object.assign(defaultUrlAtributes, dataUrlAtributes);
        const stringParams = Object.keys(urlAtributes).map(el => el + '=' + urlAtributes[el]).join("&");

        return await this.get(`usuarios?${stringParams}`);
    }
    async NovoListarUsuarios(skipToken = '', filtro = '', tamanhoPagina = 10) {
        const userSignature = HttpRequest.userSignature();
        const tenantCode = userSignature.tenantCode;
        const codigoCliente = userSignature.accountNumber ? userSignature.accountNumber : '';

        return await this.get(`usuarios?tenantCode=${tenantCode}&codigoCliente=${codigoCliente}&skipToken=${skipToken}&filtro=${filtro}&tamanhoPagina=${tamanhoPagina}`);
    }
    async ListarUsuariosGrupo(skipToken = '', filtro = '', tamanhoPagina = 10) {
        const userSignature = HttpRequest.userSignature();
        const tenantCode = userSignature.tenantCode;
        const codigoCliente = userSignature.accountNumber ? userSignature.accountNumber : '';

        return await this.get(`usuarios/ListarUsuariosGrupo365?tenantCode=${tenantCode}&codigoCliente=${codigoCliente}&skipToken=${skipToken}&filtro=${filtro}&tamanhoPagina=${tamanhoPagina}`);
    }
    async ListarPerfisDeAcesso(usuarioId) {
        return await this.get(`usuarios/ListarPerfisDeAcesso?usuarioId=${usuarioId}`)
    }
    async ValidarHabilitacaoGestaoUsuarios() {
        const direitoId = HttpRequest.userSignature().entitlementId;
        return await this.get(`usuarios/ValidarHabilitacaoGestaoUsuarios?direitoId=${direitoId}`)
    }
    async ObterUltimoLogCriacaoMultiplosUsuarios() {
        const direito = HttpRequest.userSignature();

        return await this.get(`Usuarios/ObterUltimoLogCriacaoMultiplosUsuarios?tenantId=${direito.axtTenantId}&clienteId=${direito.accountId}`);
    }
    async CriarUsuario(usuarioDTO) {
        return await this.post("Usuarios/", usuarioDTO);
    }
    async EnviarPedidoCriacaoMultiplosUsuarios(pedidoCriacaoUsuariosDTO) {
        return await this.post("Usuarios/EnviarPedidoCriacaoMultiplosUsuarios", pedidoCriacaoUsuariosDTO, true, true);
    }
    async GerarLinkDownloadUltimoArquivoMultiplosUsuarios(logOperacaoId) {
        return await this.post(`Usuarios/GerarLinkDownloadUltimoArquivoMultiplosUsuarios?logOperacaoId=${logOperacaoId}`);
    }
    async GerarLinkDownloadErrosMultiplosUsuarios(logOperacaoId) {
        return await this.post(`Usuarios/GerarLinkDownloadErrosMultiplosUsuarios?logOperacaoId=${logOperacaoId}`);
    }
    async CancelarOperacaoCriacaoMultiplosUsuarios(logOperacaoId) {
        await this.post(`Usuarios/CancelarOperacaoCriacaoMultiplosUsuarios?logOperacaoId=${logOperacaoId}`);
    }
    async ProcessarPedidoCriacaoMultiplosUsuarios(criacaoMultiplosUsuariosDTO) {
        return await this.post("Usuarios/ProcessarPedidoCriacaoMultiplosUsuarios", criacaoMultiplosUsuariosDTO);
    }
    async EditarUsuario(usuarioDTO) {
        return await this.put("Usuarios/", usuarioDTO);
    }
    async RedefinirMinhaSenha(redefinirSenhaDTO) {
        return await this.put("usuarios/RedefinirMinhaSenha", redefinirSenhaDTO, false);
    }
    async EditarLicenciamento(editarLicenciamentoDTO) {
        return await this.patch("Usuarios/EditarLicenciamento", editarLicenciamentoDTO);
    }
    async AtualizarMeusDados(meusDados) {
        return await this.patch("Usuarios/EditarMeusDados", meusDados);
    }
    async ExcluirUsuario(excluirUsuarioDto) {
        return await this.delete("Usuarios/", excluirUsuarioDto);
    }
    async ObterUsuario365PorUsuarioAutenticado() {
        return await this.get(`usuarios/ObterUsuario365AtivoPorUsuarioAutenticado`)
    }
    async AlterarEstadoDoUsuarioNoTenant(alteracaoEstadoDoUsuarioNoTenantDTO) {    
        return await this.patch("usuarios/AlterarEstadoDoUsuarioNoTenant", alteracaoEstadoDoUsuarioNoTenantDTO);
    }
    async ObterUsuarioExcluido(usuarioId, tenantCode) {
        return await this.get(`usuarios/ObterUsuarioExcluido?tenantCode=${tenantCode}&usuarioId=${usuarioId}`)
    }
    async ListarUsuariosExcluidos(skipToken = '', filtro = '', tamanhoPagina = 10) {
        const userSignature = HttpRequest.userSignature();
        const tenantCode = userSignature.tenantCode;
        const codigoCliente = userSignature.accountNumber ? userSignature.accountNumber : '';

        return await this.get(`usuarios/ListarUsuariosExcluidos?tenantCode=${tenantCode}&codigoCliente=${codigoCliente}&skipToken=${skipToken}&filtroPalavraChave=${filtro}&tamanhoPagina=${tamanhoPagina}`);
    }	
	async RestaurarUsuario(data){
		return await this.post(`usuarios/RestaurarUsuario`, data)
	}
    async ObterUsuario(usuarioId, tenantCode) {
        const _tenantCode = tenantCode ?? HttpRequest.userSignature().tenantCode;
        return await this.get(`usuarios/ObterUsuario?tenantCode=${_tenantCode}&usuarioId=${usuarioId}`, true, { ignorarLogoutEm401: true });
    }
    async ObterFoto(loginUsuario, tenantCode) {
        return await this.get(`usuarios/ObterFoto?tenantCode=${tenantCode}&loginUsuario=${loginUsuario}&tamanho=48x48`, true, { ignorarLogoutEm401: true });
    }
    async RedefinirMFA(usuarioId) {
        const userSignature = HttpRequest.userSignature();
        const data = {
            tenantCode: userSignature.tenantCode,
            usuarioId: usuarioId,
            direitoId: userSignature.entitlementId
        };
        return await this.patch("usuarios/RedefinirMFA", data);
    }
    async AlterarSenha(changeData) {
        const userSignature = HttpRequest.userSignature();
        const data = {
            tenantCode: userSignature.tenantCode,
            loginUsuario: changeData.upn,
            perfilSenha: {
                forcarAlteracaoNoProximoLogin: changeData.forceChange,
                senha: btoa(changeData.password)
            },
            acionadoPeloPortalDoCliente: true
        };
        return await this.patch("usuarios/AlterarSenha", data);
    }
}

export default new UsuariosService();